import { render, staticRenderFns } from "./SkeletonVcDemo.vue?vue&type=template&id=52efd2be&scoped=true&"
import script from "./SkeletonVcDemo.vue?vue&type=script&lang=js&"
export * from "./SkeletonVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonVcDemo.vue?vue&type=style&index=0&id=52efd2be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52efd2be",
  null
  
)

export default component.exports